import {ProductDataStore} from "../../stores/productDataStore";
import {ProductDataService} from "../../services/productDataService";
import {UIService} from "../UIService";
import {PriceFormatter} from "../../services/priceFormatter";
import {DrawingDataService} from "../drawingComponent/drawingDataService";
import {CustomerTypeService} from "../../services/customerTypeService";
import {PriceService} from "../../services/priceService";

export class GlazingPackageService {
    private productDataStore: ProductDataStore;
    private uiService: UIService;
    private customerTypeService: CustomerTypeService;
    private priceService: PriceService;
    private priceFormatter: PriceFormatter;
    private drawingsDataService: DrawingDataService;

    public readonly aluminiumSpacer = 1;
    public readonly warmEdgeSpacer = 2;
    private productDataService: ProductDataService;

    constructor() {
        this.productDataStore = new ProductDataStore();
        this.productDataService = new ProductDataService();
        this.uiService = new UIService();
        this.customerTypeService = new CustomerTypeService();
        this.priceService = new PriceService();
        this.priceFormatter = new PriceFormatter();
        this.drawingsDataService = new DrawingDataService();
    }

    resetSelectedOptions() {
        let initialGlazingSpacerId = this.productDataStore.getInitialOptionByName('glazingSpacers').id;

        this.productDataService.updateSelectedOptionByName('glazingSpacers', initialGlazingSpacerId, true);
        this.uiService.resetSelectionsByPartName('glazingSpacer');
        this.uiService.setSelectedOption(this.uiService.getElementByPartNameAndId('glazingSpacer', initialGlazingSpacerId));
    }

    reloadProductWithNewGlazing(newGlazingId) {
        const currentGlazingId = this.productDataStore.getSelectedOptionIdByName('glazing');
        const currentGlazing = this.productDataStore.getAvailableOptionByNameAndId('glazing', currentGlazingId);
        const newGlazing = this.productDataStore.getAvailableOptionByNameAndId('glazing', newGlazingId);
        let currentGlassNumber = '';
        let newGlassNumber = '';

        if (currentGlazing.attributes.width === newGlazing.attributes.width) {
            return false;
        }

        if (+currentGlazing.attributes.chambers === 1) {
            currentGlassNumber = '2-glas';
            newGlassNumber = '3-glas';
        } else {
            currentGlassNumber = '3-glas';
            newGlassNumber = '2-glas';
        }

        const newProductSlug = this.productDataStore.getProductInfoAttributeByName('productSlug').replace(currentGlassNumber, newGlassNumber);
        const serieId = this.productDataStore.getSelectedOptionIdByName('series');
        this.productDataService.reloadProductWithNewSerie(serieId, newProductSlug);
    }

    setDefaultGlazingSpacerColor(isWhite) {
        const defaultGlazingSpacers = this.productDataStore.getAttributeByName('defaultGlazingSpacerForColors');

        if (
            defaultGlazingSpacers &&
            !this.productDataStore.getProductInfoAttributeByName('isDefaultSpacerAluminium')
        ) {
            if (isWhite) {
                this.productDataService.updateSelectedOptionByName('glazingSpacers', defaultGlazingSpacers.white, true);
                this.uiService.resetSelectionsByPartName('glazingSpacer');
                this.uiService.setSelectedOption(this.uiService.getElementByPartNameAndId('glazingSpacer', defaultGlazingSpacers.white));
            } else {
                this.productDataService.updateSelectedOptionByName('glazingSpacers', defaultGlazingSpacers.other, true);
                this.uiService.resetSelectionsByPartName('glazingSpacer');
                this.uiService.setSelectedOption(this.uiService.getElementByPartNameAndId('glazingSpacer', defaultGlazingSpacers.other));
            }
            this.uiService.displayTopNotification('spacerColorChangedNotice');
        }
    }

    public getGlazingSpacerPrice(priceAfterDiscount: number): string {
        if (this.customerTypeService.isB2bCustomer()) {
            priceAfterDiscount = this.priceService.calculateNetPrice(priceAfterDiscount);
        }

        return this.priceFormatter.getPriceWithCurrency(this.drawingsDataService.getGlassSquareMeterArea() * priceAfterDiscount, true) + ' (' +
            this.priceFormatter.getPriceWithCurrency(priceAfterDiscount, false, true) + ')';
    }
}

